import React from 'react';
import ForgotPasswordContainer from '../../components/auth/forgotPasswordContainer';

const ForgotPassword = () => (
  <ForgotPasswordContainer />
)

export default ForgotPassword;
